import { stateGo } from 'redux-ui-router';
import { authLogin } from 'logic/auth';
import { setNavType } from 'logic/theme';
import { selectProduct, submitTransactionData } from 'logic/signup';

import {
  changeSubscription,
  fetchMember,
  selectMember,
  selectSubscription,
  selectHasProgramSubscription,
  updateMember,
  updateMemberField,
  updateMemberStep,
} from 'logic/member';

export const WelcomeSteps = {
  template: `
    <div class="h-100" ng-hide="$ctrl.auth.token">
      <main class="main-content theme-mid"
        scroll-top-on-change="$ctrl.step">
        <div class="container">
          <div class="row"
            ng-switch="$ctrl.step">
            <div class="col-12 mx-auto">
              <welcome-step-password
                ng-switch-when="0"
                member="$ctrl.member"
                is-loading="$ctrl.isLoading"
                on-submit="$ctrl.onSubmit(data)">
              </welcome-step-password>
              <welcome-step-profile
                ng-switch-when="1"
                member="$ctrl.member"
                is-loading="$ctrl.isLoading"
                on-update="$ctrl.updateMemberField(key, value)"
                on-upload-complete="$ctrl.fetchMember(id)"
                on-submit="$ctrl.onSubmit(data)">
              </welcome-step-profile>
            </div>
            <div class="col-12 col-lg-10 mx-auto" ng-switch-when="2">
              <div ng-switch="$ctrl.voomeProductType">
                <div ng-switch-when="program">
                  <welcome-step-programs
                    is-loading="$ctrl.isLoading"
                    member="$ctrl.member"
                    on-submit="$ctrl.onSubmit(data)"
                    on-update="$ctrl.updateMemberField(key, value)"
                    scroll-to="$ctrl.onScrollTo(id)">
                    <welcome-step-actions
                      on-cancel="$ctrl.onCancel()"
                      is-loading="$ctrl.isLoading">
                      Let's Start
                    </welcome-step-actions>
                  </welcome-step-programs>
                </div>
                <div ng-switch-when="weekly">
                  <div ng-switch="$ctrl.slug">
                    <div ng-switch-when="belgravia-nutrition">
                      <welcome-step-nutrition
                        member="$ctrl.member"
                        is-loading="$ctrl.isLoading"
                        is-show-modal="$ctrl.isShowModal"
                        on-update="$ctrl.updateMemberField(key, value)"
                        on-submit="$ctrl.onSubmit(data)"
                        scroll-to="$ctrl.onScrollTo(id)">
                        <welcome-step-actions
                          on-cancel="$ctrl.onCancel()"
                          is-loading="$ctrl.isLoading">
                          Let's Start
                        </welcome-step-actions>
                      </welcome-step-nutrition>
                    </div>
                    <div ng-switch-when="voome-workouts">
                      <welcome-step-workout
                        member="$ctrl.member"
                        is-loading="$ctrl.isLoading"
                        on-update="$ctrl.updateMemberField(key, value)"
                        on-submit="$ctrl.onSubmit(data)"
                        scroll-to="$ctrl.onScrollTo(id)">
                        <welcome-step-actions
                          on-cancel="$ctrl.onCancel()"
                          is-loading="$ctrl.isLoading">
                          Let's Start
                        </welcome-step-actions>
                      </welcome-step-workout>
                    </div>
                  </div>
                </div>
                <div ng-switch-when="bundle">
                  <welcome-step-bundle
                    member="$ctrl.member"
                    is-loading="$ctrl.isLoading"
                    on-update="$ctrl.updateMemberField(key, value)"
                    on-submit="$ctrl.onSubmit(data)"
                    on-cancel="$ctrl.onCancel()"
                    scroll-to="$ctrl.onScrollTo(id)">
                  </welcome-step-bundle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>`,

  controller($ngRedux, $location, $anchorScroll, $window) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Allow for the navbar when jumping to next question.
        $anchorScroll.yOffset = 65;

        $location.hash(null);
        this.setNavType('plain');

        // Redirect to landing page on step 3.
        this.unsubscribe = $ngRedux.subscribe(() => {
          if (this.subscription && this.step === 3) {
            this.unsubscribe();
            this.setNavType('main');
            this.changeSubscription(this.subscription);
          }
        });
      },

      $onDestroy() {
        $anchorScroll.yOffset = 0;
        this.disconnect();
        this.unsubscribe();
      },

      onScrollTo(id) {
        $location.hash(id);
        $anchorScroll();
      },

      onSubmit(data = {}) {
        const { id } = this.member;
        const { step, isWeekly, voomeProductId } = this.subscription;

        switch (step) {
          case 0:
            const { password } = data;

            id && password
              ? this.updateMemberStep({ id, password }, 1)
              : this.authLogin(data);
            break;

          case 1:
            this.submitTransactionData(id, this.subscription);
            this.updateMemberStep(data, 2);
            break;

          case 2:
            this.updateMemberStep(data, 3);
            break;
        }
      },

      onCancel() {
        $window.location.reload();
      },

      mapState({ member, router, signup }) {
        const subscription = selectSubscription(member);
        const isUpgrade = router.currentState.name === 'welcomeUpgrade';
        const { isLoading } = member;
        const { step } = subscription;

        // Adjust slug if its an upgrade.
        const slug = isUpgrade ? router.currentParams.slug : subscription.slug;

        // Adjust voomeProductType if its an upgrade.
        const voomeProductType = 'weekly';

        return {
          slug,
          step,
          subscription,
          voomeProductType,
          isLoading,
          isShowModal: selectHasProgramSubscription(member),
          member: selectMember(member),
        };
      },

      mapDispatch() {
        return {
          authLogin,
          changeSubscription,
          fetchMember,
          setNavType,
          submitTransactionData,
          stateGo,
          updateMember,
          updateMemberField,
          updateMemberStep,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/WelcomeSteps.js